import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const roleBadgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      role: {
        buyer: "bg-[hsl(var(--role-buyer))] text-[hsl(var(--role-buyer-foreground))]",
        seller: "bg-[hsl(var(--role-seller))] text-[hsl(var(--role-seller-foreground))]", 
        admin: "bg-[hsl(var(--role-admin))] text-[hsl(var(--role-admin-foreground))]",
      },
    },
    defaultVariants: {
      role: "buyer",
    },
  }
);

export interface RoleBadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof roleBadgeVariants> {
  role: "buyer" | "seller" | "admin" | null | undefined;
}

function RoleBadge({ className, role, ...props }: RoleBadgeProps) {
  // Handle null/undefined role gracefully
  if (!role) {
    return null;
  }
  
  const formatRole = (role: string) => {
    return role.charAt(0).toUpperCase() + role.slice(1);
  };

  return (
    <span
      className={cn(roleBadgeVariants({ role: role as "buyer" | "seller" | "admin" }), className)}
      {...props}
    >
      {formatRole(role)}
    </span>
  );
}

export { RoleBadge, roleBadgeVariants };